import clsx from "clsx";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { fieldFallbackLabel, GroupItem } from "../../types";
import { Label } from "../field-components";

export const GroupContainer = ({
  group,
  children,
  className,
}: {
  group: GroupItem;
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={twMerge(
      "rounded border border-neutral-100 bg-neutral-20",
      className,
    )}
  >
    <div className="px-[2.4rem] border-b border-neutral-100">
      <div className="w-fit py-[1.2rem] border-b-2 border-neutral-500">
        <Label {...group} type="group" fontSize="paragraph" description="" />
      </div>
    </div>
    {group.description && (
      <div className="pt-[1.6rem] px-[2.4rem]">
        <Label {...group} type="group" hideLabel />
      </div>
    )}
    <div
      className={clsx(
        "flex flex-col gap-large px-[2.4rem] py-[2.4rem]",
        group.description && "pt-[1.6rem]",
      )}
    >
      {children}
    </div>
  </div>
);

export const GroupFieldSetContainer = ({
  group,
  index,
  children,
  className,
}: {
  group: GroupItem;
  index: number;
  children: ReactNode;
  className?: string;
}) => (
  <fieldset
    className={twMerge(
      "flex flex-col p-[2.4rem] gap-medium border border-neutral-150 rounded bg-white",
      className,
    )}
    aria-label={
      group.repeatable
        ? `${group.label || fieldFallbackLabel.group} ${index + 1}`
        : `${group.label}`
    }
  >
    {children}
  </fieldset>
);
